import * as constants from './ClassChineseFrm.constants';
import * as services from './ClassChineseFrm.service';

const state = {
  classChineseFrm: {},

  isRequest: false,
};

const mutations = {
  [constants.GET_CLASS_CHINESE_FRM_SUCCESS](state, classChineseFrm) {
    if (undefined !== classChineseFrm && null !== classChineseFrm) {
      state.classChineseFrm = classChineseFrm;
    }
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.DUMMY_MUTATION]() {
    //
  },
};

const actions = {
  async getClassChineseFrm({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getClassChineseFrm(payload);
    commit(constants.GET_CLASS_CHINESE_FRM_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async postClassChineseFrmConfirm({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.postClassChineseFrmConfirm(payload);
    commit(constants.DUMMY_MUTATION, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
